export default __webpack_public_path__ + "static/media/wallpaper.c7f9c84a.jpg";